<template>
    <div style="padding:12px">
        <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
           <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="角色名称" prop="name">
                        <el-input v-model="formData.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="是否可选" prop="isChoose">
                        <el-radio-group v-model="formData.isChoose">
                            <el-radio :label="1">可选</el-radio>
                            <el-radio :label="2">不可选</el-radio>
                            <el-radio :label="3">不可选但默认</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否可删" prop="ynDelete">
                        <el-radio-group v-model="formData.ynDelete">
                            <el-radio :label="1">可删</el-radio>
                            <el-radio :label="2">不可删</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="角色描述" prop="description">
                        <el-input type="textarea" :rows="4" v-model="formData.description" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import {querySchoolRoleDetail, updateSchoolRole} from '@/api/schoolManage';
    import mixin from "@/mixins/windowResize";
    export default {
        name: 'roleEdit',
        components: {BackTool},
        data() {
            return {
                id: this.$route.query.id,
                schoolId: this.$route.query.schoolId,

                platformTypeList: [],
                formData: {
                    isChoose: 1,
                    name: '',
                    description: '',
                    ynDelete: 1,
                },
                rules: {
                    name: [
                        { required: true, message: '请输入角色名称', trigger: 'blur' },
                    ],
                    isChoose: [
                        { required: true, message: '请选择是否可选', trigger: 'blur' },
                    ],
                    ynDelete: [
                        { required: true, message: '请选择是否可删', trigger: 'blur' },
                    ],
                    description: [
                        { required: true, message: '请选择所属系统', trigger: 'blur' },
                    ],
                },
            }
        },
        created() {
            querySchoolRoleDetail({
                roleId: this.id
            })
                .then(data => {
                    data.platformType = `${data.platformType}`;
                    this.formData = data;
                });
        },
        mixins: [mixin],
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            id: this.formData.id,
                            schoolId: this.formData.schoolId,
                            isChoose: this.formData.isChoose,
                            name: this.formData.name,
                            description: this.formData.description,
                            ynDelete: this.formData.ynDelete,
                        };
                        updateSchoolRole(args)
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style scoped>
.top{
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolRole/schoolRoleEdit.vue